import { interests } from '../../utils/variables';

export function loadInterestList() {
    let list = document.querySelector('.interests__container .interests__list');
    let interestsList = ``;
    for (const i of interests) {
        interestsList = interestsList.concat(`
        <div class="interest" data-interest="${i.value}">
            <span class="interest__name">${i.name}</span>
            <span class="interest__checkbox" data-interest="${i.value}">
                <i class="interest__icon-check ri-check-line"></i>
            </span>
        </div>
        `);
    }

    list.insertAdjacentHTML(
        'beforeend',
        interestsList);
}
